/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CurrencyConversionListForm_viewer$ref: FragmentReference;
declare export opaque type CurrencyConversionListForm_viewer$fragmentType: CurrencyConversionListForm_viewer$ref;
export type CurrencyConversionListForm_viewer = {|
  +id: string,
  +baseCurrency: string,
  +quoteCurrency: string,
  +quantity: number,
  +status: string,
  +approvals: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +approvedBy: {|
          +id: string,
          +username: string,
        |},
        +approvedAt: any,
      |}
    |}>
  |},
  +hasCompleteApprovals: ?boolean,
  +$refType: CurrencyConversionListForm_viewer$ref,
|};
export type CurrencyConversionListForm_viewer$data = CurrencyConversionListForm_viewer;
export type CurrencyConversionListForm_viewer$key = {
  +$data?: CurrencyConversionListForm_viewer$data,
  +$fragmentRefs: CurrencyConversionListForm_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "CurrencyConversionListForm_viewer",
  "type": "CurrencyConversionRequestNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "baseCurrency",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quoteCurrency",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "approvals",
      "storageKey": null,
      "args": null,
      "concreteType": "ApprovalNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ApprovalNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ApprovalNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "approvedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "approvedAt",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasCompleteApprovals",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7afd4167f49a522aa9456a608354432c';
module.exports = node;
